export default __webpack_public_path__ + "static/img/homepage-train-selection.33235d9.png";